import { settings } from "@pixi/settings";
import { settings as settings2 } from "@pixi/settings";
settings.RETINA_PREFIX = /@([0-9\.]+)x/;
settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;
export {
  settings2 as settings
};
//# sourceMappingURL=settings.mjs.map
